import { render, staticRenderFns } from "./ace_editor.vue?vue&type=template&id=2ffe5a5a"
import script from "./ace_editor.vue?vue&type=script&lang=js"
export * from "./ace_editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports